module.exports = __webpack_public_path__ + "media/images/result_sets/circles/3n2r6r9n-4164b376071ce36c6ef4531c44222a70.svg";